import { ReactComponent as Close } from '../../assets/icons/trvto_close.svg';

const PriceModel = ({ bookingData, newAmountPaid, priceGreater, setShowPrice }) => {
    return (
        <div
            className='ratingModal bookingModal'
            onClick={(e) => {
                e.stopPropagation();
                setShowPrice(false);
            }}
        >
            <div className='modalHeader'>
                Changed Price
                <Close className='iconSize' />
            </div>
            <div className='modalContent'>
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: '160px 140px 140px',
                        gap: '12px',
                        alignItems: 'center'
                    }}
                >
                    <div></div>
                    <div style={{ fontWeight: '600' }}>Old Price</div>
                    <div style={{ fontWeight: '600' }}>New Price</div>

                    <div>Actual</div>
                    <div style={{ textDecoration: 'line-through', color: 'black' }}>
                        ₹{bookingData.amountPaid.actual}
                    </div>
                    <div style={{ color: '#1a7f2e', fontWeight: '700' }}>₹{newAmountPaid.actual}</div>

                    <div>Tax</div>
                    <div style={{ textDecoration: 'line-through', color: 'black' }}>₹{bookingData.amountPaid.tax}</div>
                    <div style={{ color: '#1a7f2e', fontWeight: '700' }}>₹{newAmountPaid.tax}</div>

                    <div>Total</div>
                    <div style={{ textDecoration: 'line-through', color: 'black' }}>
                        ₹{bookingData.amountPaid.total}
                    </div>
                    <div style={{ color: '#1a7f2e', fontWeight: '700' }}>₹{newAmountPaid.total}</div>

                    <div>Paid</div>
                    <div style={{ textDecoration: 'line-through', color: 'black' }}>₹{bookingData.amountPaid.paid}</div>
                    <div style={{ color: '#1a7f2e', fontWeight: '700' }}>
                        ₹{priceGreater ? newAmountPaid.total : bookingData.amountPaid.paid}
                    </div>
                </div>
                {bookingData.amountPaid.paid > newAmountPaid.total ? (
                    <div className='packEditNote' style={{ marginTop: '30px' }}>
                        <p>
                            <span style={{ color: 'red', fontWeight: '600' }}>
                                ₹{bookingData.amountPaid.paid - newAmountPaid.total}
                            </span>{' '}
                            will be credited to the customer's account, as the new trip price is lower than the previous
                            booking.
                        </p>
                    </div>
                ) : (
                    <div className='packEditNote' style={{ marginTop: '30px' }}>
                        <p>
                            <span style={{ color: 'red', fontWeight: '600' }}>
                                ₹{newAmountPaid.total - bookingData.amountPaid.paid}
                            </span>{' '}
                            needs to be paid, as the new trip price is higher than the previous booking.
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PriceModel;
